import Stack from "@mui/material/Stack";
import {
  partnerByIdQueryOptions,
  partnerFormQueryOptions,
  updatePartnerAnswersMutationOptions,
} from "../../api/partners";
import { DynamicForm } from "../../dynamicForm";
import { DynamicGrid } from "../../dynamicGrid";
import { Drawer } from "../../shared/Drawer";
import { PartnerDrawerRolesSection } from "./PartnerDrawerRolesSection";
import { PartnerDrawerHeader } from "./PartnerDrawerHeader";
import { PartnerDrawerCompliancesSection } from "./PartnerDrawerCompliancesSection";
import { usePrivacyNavigate } from "../../shared/usePrivacyNavigate";
import { useMutation, useQuery } from "@tanstack/react-query";

export const PartnerMainDrawer = () => {
  const partnerId = DynamicGrid.useSelectedRowId();
  const partnerByIdQuery = useQuery(partnerByIdQueryOptions(partnerId));
  const partnerFormQuery = useQuery(partnerFormQueryOptions());
  const updateAnswersMutation = useMutation(updatePartnerAnswersMutationOptions());
  const { navigate, paths } = usePrivacyNavigate();
  return (
    <DynamicGrid.Drawer>
      {(() => {
        if (!partnerByIdQuery.data || !partnerFormQuery.data) return <Drawer.Loading />;

        const partner = partnerByIdQuery.data;

        return (
          <DynamicForm.Provider
            onSave={answer => updateAnswersMutation.mutateAsync({ partnerId: partner.id, answers: [answer] })}
            isSaving={updateAnswersMutation.isPending}
            isSaveError={updateAnswersMutation.isError}
            key={partner.id}
            answers={partner.answers}
          >
            {({ formState }) => (
              <>
                <PartnerDrawerHeader
                  partner={partner}
                  onClose={() => navigate(paths.partnersGrid())}
                  status={DynamicForm.formStateToDrawerHeaderStatus(formState)}
                />
                <Drawer.Content>
                  <Stack spacing={6}>
                    <DynamicForm.InlineForm id={partner.id} form={partnerFormQuery.data} />
                    <PartnerDrawerRolesSection partner={partner} />
                    <PartnerDrawerCompliancesSection partner={partner} />
                  </Stack>
                </Drawer.Content>
              </>
            )}
          </DynamicForm.Provider>
        );
      })()}
    </DynamicGrid.Drawer>
  );
};
